import {
  defaultRoutesShortcuts,
  defaultRoutesNames,
} from "../constants/strings";
import palette from "../components/styles/palette";

export default {
  [defaultRoutesShortcuts.NCD]: {
    routeName: defaultRoutesNames.NO_CAD_SCAN,
    variant: "light",
    background: palette.defaultRoutes[defaultRoutesShortcuts.NCD],
  },
  [defaultRoutesShortcuts.UNK]: {
    routeName: defaultRoutesNames.UNKNOWN,
    variant: "dark",
    background: palette.defaultRoutes[defaultRoutesShortcuts.UNK],
  },
  [defaultRoutesShortcuts.TBB]: {
    routeName: defaultRoutesNames.TO_BE_BOOKED_IN,
    variant: "light",
    background: palette.defaultRoutes[defaultRoutesShortcuts.TBB],
  },
  [defaultRoutesShortcuts.CFD]: {
    routeName: defaultRoutesNames.COLLECT_FROM_DEPOT,
    variant: "light",
    background: palette.defaultRoutes[defaultRoutesShortcuts.CFD],
  },
  [defaultRoutesShortcuts.FRA]: {
    routeName: defaultRoutesNames.FRAUD,
    variant: "light",
    background: palette.defaultRoutes[defaultRoutesShortcuts.FRA],
  },
  [defaultRoutesShortcuts.GOH]: {
    routeName: defaultRoutesNames.GOODS_ON_HOLD,
    variant: "dark",
    background: palette.defaultRoutes[defaultRoutesShortcuts.GOH],
  },
  [defaultRoutesShortcuts.UNASS]: {
    routeName: defaultRoutesNames.UNASSIGNED,
    variant: "dark",
    background: palette.defaultRoutes[defaultRoutesShortcuts.UNASS],
  },
};
